import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}accounting/gift-vouchers`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  getGiftVouchersByDomainId(domainIds) {
    return conduit.post('/domains/by-domain-ids', { domainIds });
  },
  downloadGiftVouchersByDomainId(domainIds) {
    return conduit.post('/domains/by-domain-ids/download', { domainIds });
  },
  getGiftVouchersByReferenceWithBooking(reference) {
    return conduit.get(`/reference/${reference}/with-booking`);
  },
  cancelGiftVoucher(reference) {
    return conduit.delete(`/reference/${reference}/cancel`);
  },
};



// WEBPACK FOOTER //
// ./src/services/gift-voucher-service/gift-voucher-service.js